import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import { useContactUs } from '@ynap/contact-us-hook';

const bem = new BEMHelper('ContactUsCTA');

const getCallNumber = (personalShopperName, freeContactNumber, call, isPlatinum) => {
    if (personalShopperName) {
        return call;
    }
    if (isPlatinum) {
        return call || freeContactNumber;
    }
    return freeContactNumber || call;
};

const ContactUsCTA = (props) => {
    const { className, selectedProduct, setUser, isSizeAndFit, productLink, isWatchExperts = false, brandId, trackEvent } = props;
    const content = useContactUs({ selectedProduct, setUser, isSizeAndFit, productLink }) || {};
    const {
        call = '',
        emailLabel,
        title,
        sendEmailStructure = {},
        isEip = false,
        isPlatinum = false,
        isHighPPItem = false,
        personalShopperName,
        personalShopperImg,
        freeContactNumber,
    } = content;
    const { email = '', subject = '', body = '' } = sendEmailStructure;
    const [error, setError] = useState(false);
    const callNumber = isWatchExperts ? getCallNumber(personalShopperName, freeContactNumber, call, isPlatinum) : call;
    if (!isEip && (brandId === 'nap' || brandId === 'mrp') && !isPlatinum) return null;

    const getClassName = () => {
        if (isPlatinum) return bem('imagePlatinum');
        if (isEip || isHighPPItem) return bem('imageEip');
        return bem('image');
    };

    const handleEmailAndPhoneClick = () => {
        trackEvent({
            event: 'select_loyalty_ps_get_in_touch',
        });
    };

    return (
        body && (
            <div className={bem(null, null, className)}>
                {personalShopperImg ? (
                    <picture>
                        {error ? (
                            <div className={bem('image')} />
                        ) : (
                            <img className={bem('imagePS')} src={personalShopperImg} alt={personalShopperName} onError={() => setError(true)} />
                        )}
                    </picture>
                ) : (
                    <div data-testid={`contact-us-cta-image${isEip ? '-eip' : isPlatinum ? '-platinum' : ''}`} className={getClassName()}></div>
                )}
                <div className={bem('container')}>
                    <p data-testid="contact-us-title" className={bem('body')}>
                        {title}
                    </p>
                    <div className={bem('contact-buttons')}>
                        <span>
                            <a
                                className={bem('contact-button', 'email')}
                                onClick={handleEmailAndPhoneClick}
                                href={`mailto:${email}?subject=${subject}&body=${body}`}
                            >
                                {emailLabel}
                            </a>
                        </span>
                        {callNumber && (
                            <span>
                                <a className={bem('contact-button', 'call')} onClick={handleEmailAndPhoneClick} href={`tel:${callNumber}`} dir="ltr">
                                    {callNumber}
                                </a>
                            </span>
                        )}
                    </div>
                </div>
            </div>
        )
    );
};

ContactUsCTA.propTypes = {
    className: PropTypes.string.isRequired,
    setUser: PropTypes.func,
    selectedProduct: PropTypes.isRequired,
    isSizeAndFit: PropTypes.bool,
    isWatchExperts: PropTypes.bool,
    productLink: PropTypes.string,
    brandId: PropTypes.string,
};

export default ContactUsCTA;
